<form (submit)="$event.preventDefault(); onSave()" class="flex flex-col gap-y-12 sm:gap-y-16">
  <!-- Email Notifications -->
  <div class="flex flex-col gap-y-10">
    <div>
      <h2 class="text-3xl leading-none font-extrabold tracking-tight text-neutral-12">
        {{ title() || 'Notifications par e-mail' }}
      </h2>
      <p class="mt-2 text-neutral-11">
        Gérez les alertes et les communications que vous recevez par e-mail dans votre boîte de réception.
      </p>
    </div>

    <!-- Section: Sécurité et compte -->
    <div class="flex flex-col">
      <div class="text-lg font-medium text-neutral-12">Sécurité et compte</div>
      <p class="mt-1 text-sm text-neutral-11">
        Restez alerté des activités sensibles liées à la sécurité de votre compte.
      </p>
      <div class="mt-6 flex flex-col gap-y-6">
        <mat-checkbox
          [formField]="formTree.securityAlerts"
          class="[&_.mdc-checkbox]:mt-0.5 [&>.mdc-form-field]:items-start"
        >
          <div class="font-medium text-neutral-12">Alertes de sécurité</div>
          <div class="text-sm text-neutral-11">
            Recevez des alertes en cas de connexion inhabituelle ou de détection d'un nouvel appareil.
          </div>
        </mat-checkbox>
      </div>
    </div>

    <mat-divider />

    <!-- Section: Activité et projets -->
    <div class="flex flex-col">
      <div class="text-lg font-medium text-neutral-12">Activité et projets</div>
      <p class="mt-1 text-sm text-neutral-11">
        Suivez les évolutions sur vos biens immobiliers, mandats et conversations en direct.
      </p>
      <div class="mt-6 flex flex-col gap-y-6">
        <mat-checkbox
          [formField]="formTree.chatMessages"
          class="[&_.mdc-checkbox]:mt-0.5 [&>.mdc-form-field]:items-start"
        >
          <div class="font-medium text-neutral-12">Messages et discussions</div>
          <div class="text-sm text-neutral-11">
            Soyez informé immédiatement lorsqu'un nouveau message vous est adressé dans la messagerie.
          </div>
        </mat-checkbox>

        <mat-checkbox
          [formField]="formTree.propertyActivity"
          class="[&_.mdc-checkbox]:mt-0.5 [&>.mdc-form-field]:items-start"
        >
          <div class="font-medium text-neutral-12">Activité des biens et mandats</div>
          <div class="text-sm text-neutral-11">
            Recevez des alertes de l'avancée des candidatures, signatures ou validations de documents.
          </div>
        </mat-checkbox>
      </div>
    </div>

    <mat-divider />

    <!-- Section: Communications et actualités -->
    <div class="flex flex-col">
      <div class="text-lg font-medium text-neutral-12">Communications et actualités</div>
      <p class="mt-1 text-sm text-neutral-11">
        Choisissez les informations et résumés périodiques que vous souhaitez recevoir.
      </p>
      <div class="mt-6 flex flex-col gap-y-6">
        <mat-checkbox
          [formField]="formTree.productUpdates"
          class="[&_.mdc-checkbox]:mt-0.5 [&>.mdc-form-field]:items-start"
        >
          <div class="font-medium text-neutral-12">Nouveautés et mises à jour du produit</div>
          <div class="text-sm text-neutral-11">
            Découvrez les nouvelles fonctionnalités, améliorations et conseils d'utilisation de la plateforme.
          </div>
        </mat-checkbox>

        <mat-checkbox
          [formField]="formTree.weeklyDigest"
          class="[&_.mdc-checkbox]:mt-0.5 [&>.mdc-form-field]:items-start"
        >
          <div class="font-medium text-neutral-12">Récapitulatif hebdomadaire</div>
          <div class="text-sm text-neutral-11">
            Un résumé condensé de l'activité du marché, de vos statistiques et de vos projets envoyé une fois
            par semaine.
          </div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <mat-divider />

  <!-- Actions -->
  <div class="flex justify-end gap-x-3">
    <button
      matButton
      type="button"
      class="tertiary"
      [disabled]="!isDirty() || isSaving()"
      (click)="onCancel()"
    >
      Annuler
    </button>
    <button matButton type="submit" class="primary" [disabled]="!isDirty() || isSaving()">
      @if (isSaving()) {
        Enregistrement en cours...
      } @else {
        Enregistrer les modifications
      }
    </button>
  </div>
</form>
